import React, { useEffect, useState } from 'react';
import { format, addMonths, subDays } from 'date-fns';
import { Link } from 'react-router-dom';
import icArrow from '@assets/images/icon_arrow_right_gray.svg';
import Header from '@components/shared/header';
import BottomNav from '@components/shared/bottomNav';
import AddTrackingModal from '@components/modal/addTracking';
import CheckIsLogin from '@components/checkIsLogin';
import { common, valids } from '@config/index';
import { formatYyMmddd, sleep } from '@utils/common';
import useStore from '@store/index';
import ConsignmentApi from '@api/consignment/consignment.query';
// import { consignmentData } from '@temp/consignmentData';

function Page() {
  const { setLoading } = useStore((state) => state);
  const [consignmentId, setConsignmentId] = useState<number | undefined>(
    undefined,
  );
  const [invoiceOpen, setInvoiceOpen] = useState(false);

  // api
  const {
    data: callData,
    isLoading,
    refetch,
  } = ConsignmentApi.useConsignmentHistoryQuery();
  const resultData = callData?.data?.data;
  const listData = resultData?.result ?? [];

  useEffect(() => {
    // console.log(listData);
    if (resultData !== undefined && !isLoading) {
      (async () => {
        await sleep(400);
        setLoading(false);
      })();
    } else setLoading(true);
  }, [resultData, isLoading]);

  return (
    <>
      <CheckIsLogin loginCheck={false} />
      <div id="root_layout">
        <div className="root_container">
          <div className="sticky_menu">
            <Header title="위탁 내역" back="/mypage" searchCart />
          </div>

          <div className="mypage_consignment_wrap pb-24 pt-4">
            <div className="inner">
              <div className="info_area">
                <ul>
                  <li>
                    <span>
                      {Number(
                        resultData?.status?.application ?? 0,
                      ).toLocaleString()}
                    </span>
                    <p>신청완료</p>
                  </li>
                  <li>
                    <span>
                      {Number(
                        resultData?.status?.diagnosis ?? 0,
                      ).toLocaleString()}
                    </span>
                    <p>진단중</p>
                  </li>
                  <li>
                    <span>
                      {Number(
                        resultData?.status?.consigning ?? 0,
                      ).toLocaleString()}
                    </span>
                    <p>위탁중</p>
                  </li>
                  <li>
                    <span>
                      {Number(resultData?.status?.end ?? 0).toLocaleString()}
                    </span>
                    <p>위탁 종료</p>
                  </li>
                  <li>
                    <span>
                      {Number(
                        resultData?.status?.impossible ?? 0,
                      ).toLocaleString()}
                    </span>
                    <p>위탁 불가</p>
                  </li>
                </ul>
              </div>

              <ul className="mt-4 flex flex-col gap-8">
                {listData?.length > 0 ? (
                  listData?.map((item) => {
                    const consigningEndDate = item?.consigningDate
                      ? format(
                          subDays(
                            addMonths(
                              item?.consigningDate,
                              item?.consignmentPeriod,
                            ),
                            1,
                          ),
                          'yyyy-MM-dd',
                        )
                      : '';

                    return (
                      <li key={item.id}>
                        <div className="flex items-center justify-between border-b border-b-gray-c pb-2">
                          <p className="text-xs font-medium text-gray-9">
                            위탁번호 {item.consignmentNumber ?? '-'}
                          </p>
                          <Link
                            to={`/mypage/consignment/detail/${item.id}`}
                            className="flex items-center gap-1 text-xs font-medium text-gray-9"
                          >
                            상세 정보 <img src={icArrow} alt="arrow" />
                          </Link>
                        </div>
                        <div className="item_area pt-4">
                          <div className="img_wrap w-25">
                            <div className="img_area">
                              {item.product?.product_images?.length > 0 ? (
                                <img
                                  src={`${common.imageUrl}/${item.product?.product_images?.[0]?.file?.fileUrl}`}
                                  alt="상품 이미지"
                                />
                              ) : (
                                <i className="no_data_img" />
                              )}
                            </div>
                          </div>
                          <div className="text_area">
                            <div className="mb-3">
                              {item.status === 'application' ? (
                                <p className="status text-black">신청 완료</p>
                              ) : item.status === 'diagnosis' ? (
                                <p className="status text-main">진단 중</p>
                              ) : item.status === 'consigning' ? (
                                <p className="status text-main">위탁 중</p>
                              ) : item.status === 'end' ? (
                                <p className="status text-black">위탁 종료</p>
                              ) : item.status === 'impossible' ? (
                                <p className="status text-gray-9">위탁 불가</p>
                              ) : null}
                            </div>
                            <p className="brand">
                              {item?.product?.brand?.nameEnglish.toUpperCase() ??
                                ''}
                            </p>
                            <p className="product">
                              {item?.product?.productName ?? ''}
                            </p>
                            {(item.status === 'consigning' ||
                              item.status === 'end') && (
                              <div className="mt-3">
                                <span className="desc">
                                  감정한 일 렌트 금액
                                </span>
                                <p className="price_total">
                                  {Number(
                                    item?.assessedRentalPrice ?? 0,
                                  ).toLocaleString()}
                                </p>
                              </div>
                            )}
                            {item?.consigningDate && (
                              <p className="desc mt-3">
                                계약기간 :{' '}
                                {formatYyMmddd(item?.consigningDate ?? '')} -{' '}
                                {formatYyMmddd(consigningEndDate ?? ' ')}
                              </p>
                            )}
                          </div>
                        </div>
                        {item.status === 'application' && (
                          <button
                            type="button"
                            className="btn btn_style01 mt-4 h-10 w-full rounded-sm text-sm font-medium"
                            onClick={() => {
                              setConsignmentId(item?.id ?? undefined);
                              setInvoiceOpen(true);
                            }}
                          >
                            송장번호 입력
                          </button>
                        )}
                      </li>
                    );
                  })
                ) : (
                  <li className="no_data_text py-1 text-center">
                    <p>{valids.noDataConsignment}</p>
                  </li>
                )}
              </ul>
            </div>
          </div>

          <AddTrackingModal
            open={invoiceOpen}
            setOpen={setInvoiceOpen}
            id={consignmentId}
            refetch={refetch}
          />

          <BottomNav active="MYPAGE" />
        </div>
      </div>
    </>
  );
}
export default Page;
